import React, { Component } from 'react'
import { ApolloProvider } from 'react-apollo'
import { Provider as ReduxProvider } from 'react-redux'
import graphqlClient from 'lib/graphql'
import configureStore from '../store'
import { UserContextProvider } from '../context/UserContext'
import ErrorBoundary from 'components/ErrorBoundary'
import ErrorPage from 'components/ErrorPage'
import Routes from '../routes'

const store = configureStore()

// Root handles initializing the app.
class Root extends Component {
  render() {
    return (
      <ErrorBoundary errorComponent={ErrorPage}>
        <ReduxProvider store={store}>
          <ApolloProvider client={graphqlClient}>
            <UserContextProvider>
              <Routes />
            </UserContextProvider>
          </ApolloProvider>
        </ReduxProvider>
      </ErrorBoundary>
    )
  }
}

export default Root
